// extracted by mini-css-extract-plugin
module.exports = {"loaderRing":"Loader_loaderRing__sATXd"};